import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Typography,
  CircularProgress,
  Button
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const MagicLogin = () => {
  const { completeLogin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      setError('Magic link token missing. Please request a new link.');
      setIsLoading(false);
      return;
    }

    const exchangeToken = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/auth/magic-login`, { token });

        if (response.data.success) {
          await completeLogin(response.data.token, response.data.user);
          const redirect = response.data.redirect || '/user/coupons';
          navigate(redirect, { replace: true });
        } else {
          setError(response.data.message || 'Unable to login with the provided link.');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Magic link expired or invalid. Please request a new link.');
      } finally {
        setIsLoading(false);
      }
    };

    exchangeToken();
  }, [location.search, navigate, completeLogin]);

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="h6">Opening your coupons...</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center',
        px: 2,
      }}
    >
      <Typography variant="h5" color="error">
        {error}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Your magic link may have expired. Please request a fresh link from KNLS support or login manually.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/user-login')}>
        Go to Login
      </Button>
    </Box>
  );
};

export default MagicLogin;


